import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { MessageUtil } from '../../../../../util/MessageUtil';
import FormGridFw, { FORM_GRID_MODE } from '../../../../../framework/form-grid/FormGridFw';
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { getValidationEstacionModal } from './getValidationEstacionModal';
import { EnvConstants } from '../../../../../EnvConstants';

export class AgregarGrupoFacturaModal extends BasePage {
    constructor(props) {
        super(props);
        this.estacionData = {};
    };

    createPageProperties = (pageApi) => {
        return {
            validation: getValidationEstacionModal,
        };
    }

    renderPage(pageApi) {
        const validarForm = () => {
            if (this.estacionData.nombre_grupo_facturacion === "" || !this.estacionData.nombre_grupo_facturacion) {
                MessageUtil(
                    "warning",
                    "Alerta!",
                    "Nombre de Grupo Facturación es requerido"
                );
                
                return false;
            }
            return true;
        }

        const barButtonconfig = {
            fields:[
                {...BUTTON_DEFAULT.SAVE , onClick: () => {
                    
                    if (validarForm()) {
                        const data = {
                            id_empresa: pageApi.name.data.id_empresa,
                            id_pers_contac: pageApi.name.data.id_pers_contac,
                            id_division: 1,
                            nombre_grupo_facturacion: this.estacionData.nombre_grupo_facturacion,
                        };

                        LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                            queryId: 850,
                            params: data,
                            fnOk: (res) => {
                                if(!res?.error) {
                                    MessageUtil("success", "Operación realizada con éxito.", "");
                                    pageApi.hideThisModal();
                                    pageApi.name.fnLoadForm()
                                } else {
                                    MessageUtil("error", res.message, "");
                                }  
                            }
                        })
                    }
                    

                }},
            ]
        }

        const formConfig = {
            mode: FORM_GRID_MODE.FORM_ADD,
            afterAddEvent: (data) => {
                console.log(data)
                pageApi.getEvent('afterAddEvent')(data);
                pageApi.hideThisModal();
            },
            form: {
                fields:[
                    {name:'nombre_grupo_facturacion', label:'Nombre Grupo Facturación', column: 12, onChange: (value, values) => { this.estacionData.nombre_grupo_facturacion = value }, required: true},
                ]
            },
            bar: barButtonconfig
        } 

    
        return (
            <>
                <FormFw
                    name="grupoFacturaForm" 
                    getParentApi={pageApi.getApi}
                    config={formConfig.form}
                />
                <BarButtonFw
                    name="bar"
                    getParentApi={pageApi.getApi}
                    config={barButtonconfig}
                />
            </>
        )

    }
    
}